<template lang="pug">
v-tooltip(bottom)
  template(#activator="{ on, attrs }")
    v-btn.mx-1(
      v-show="fields.length"
      icon
      v-bind="attrs"
      v-on="on"
      @click="$emit('input', !value)"
    )
      v-badge(
        :value="count"
        :content="count"
        bordered
        overlap
        bottom
        color="warning"
      )
        v-icon
          | mdi-filter
  span
    span.text-md.font-weight-medium Filtrar
    br
    span.font-weight-light Exibe ou oculta a caixa de filtragem da grade
</template>

<style>
  .x-btn-navbar {
    border: 1px solid #9995;
  }
</style>

<script>
export default {
  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,
  },

  computed: {
    fields: vm => vm.filter?.fields || [],

    count () {
      const appliedFields = this.fields.filter(field =>
        field != 'undefined' && field.value != null)
      return appliedFields.length
    },
  },
}
</script>